import React from 'react';

interface EmptyProps {
    isError?: boolean;
    text?: string;
}

const Empty: React.FC<EmptyProps> = ({isError = false, text}) => (
    <main
        style={{
            width: 'fit-content',
            height: '100vh',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}
    >
        <img
            src="//hks.gsxcdn.com/2343462962_bh6oiq0x.png"
            style={{
                width: '160px',
                height: '160px',
            }}
            alt="Empty state"
        />
        <div
            style={{
                marginTop: '20px',
                color: '#666',
                fontSize: '14px',
                fontWeight: 400,
                textAlign: 'center',
            }}
        >
            {text || (isError ? '渲染异常' : '发布后才会有相关报表内容哦')}
        </div>
    </main>
);

export default Empty;
